export const blockIconsTextformattingInventoryNew = (
	<span className='material-symbols-outlined'>inventory</span>
);
